import { combineReducers } from 'redux';

import { LOGOUT_SUCCESS } from 'auth';

import { reducer as contacts } from '../contacts';

import { reducer as common } from './commonReducer';
import { reducer as users } from '../users';
import { reducer as tasks } from '../tasks';
import { reducer as analytics } from '../analytics';
import { reducer as finances } from '../finances';
import { reducer as linkDistribution } from '../link_distribution/_redux/index';

const reducers = combineReducers({ contacts, common, users, tasks, analytics, finances, linkDistribution });

const reducer = (state, action) => {
  if (action.type === LOGOUT_SUCCESS) {
    state = undefined;
  }

  return reducers(state, action);
};

export default reducer;
